'use strict';

import React, { Fragment } from 'react';
import Select from 'Components/Forms/Elements/Select';
import Switch from 'Components/Forms/Elements/Switch';
import bemit from 'Functions/bemit';
import { coworking_place_types as type_options } from 'Shared/options';
const {
  app,
  moment
} = window;
const MIN_H = 7,
  MAX_H = 23;
const hour_options = Array.from({
  length: MAX_H - MIN_H + 1
}, function (v, i) {
  const hour = i + MIN_H;
  return {
    value: String(hour),
    label: hour + 'h'
  };
});
moment.locale('en');
const en_days = Array.from({
  length: 7
}, function (v, i) {
  return moment().startOf('isoWeek').add(i, 'days').format('dddd').toLowerCase();
});
moment.locale('fr');
const schedule = Array.from({
  length: 7
}, function (v, i) {
  const prefix = 'coworkingspace[schedule][';
  let name = prefix + en_days[i] + ']';
  const day_name = moment().startOf('isoWeek').add(i, 'days').format('dddd');
  const config = {
    name: en_days[i],
    form_name: name,
    label: day_name.slice(0, 1).toUpperCase() + day_name.slice(1)
  };
  return config;
});
export default function ScheduleConfig(props) {
  const state = props.state;
  const is__half_type = props.type !== 'a_calm_coworking_space';
  const modifiers = is__half_type ? ['half'] : ['not-half'];
  const header = /*#__PURE__*/React.createElement("div", {
    className: bemit('c-schedule-config', ['header'].concat(modifiers))
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-schedule-config__item day"
  }), is__half_type ? /*#__PURE__*/React.createElement("div", {
    className: "c-schedule-config__item half"
  }) : undefined, /*#__PURE__*/React.createElement("div", {
    className: "c-schedule-config__item open"
  }, "Ouvert"), /*#__PURE__*/React.createElement("div", {
    className: "c-schedule-config__item from"
  }, "De"), /*#__PURE__*/React.createElement("div", {
    className: "c-schedule-config__item to"
  }, "\xC0"), is__half_type ? /*#__PURE__*/React.createElement("div", {
    className: "c-schedule-config__item sep"
  }) : undefined, is__half_type ? /*#__PURE__*/React.createElement("div", {
    className: "c-schedule-config__item half"
  }) : undefined, is__half_type ? /*#__PURE__*/React.createElement("div", {
    className: "c-schedule-config__item open"
  }, "Ouvert") : undefined, is__half_type ? /*#__PURE__*/React.createElement("div", {
    className: "c-schedule-config__item from"
  }, "De") : undefined, is__half_type ? /*#__PURE__*/React.createElement("div", {
    className: "c-schedule-config__item to"
  }, "\xC0") : undefined);
  const rows = schedule.map(function (config, i) {
    const {
      label,
      form_name
    } = config;
    const open_name = is__half_type ? '[morning]' : '[open]';
    let from_name = is__half_type ? '[morning_from]' : '[from]';
    let to_name = is__half_type ? '[morning_to]' : '[to]';
    const output = /*#__PURE__*/React.createElement("div", {
      className: bemit('c-schedule-config', modifiers),
      key: form_name
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-schedule-config__item day"
    }, label), is__half_type ? /*#__PURE__*/React.createElement("div", {
      className: "c-schedule-config__item half"
    }, "Matin") : undefined, /*#__PURE__*/React.createElement("div", {
      className: "c-schedule-config__item open"
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: props.onChange,
      value: state[form_name + open_name],
      name: form_name + open_name,
      "left-label": "Non",
      label: "Oui",
      status: state.status_messages,
      className: "mui-switch-centered"
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-schedule-config__item from"
    }, /*#__PURE__*/React.createElement(Select, {
      options: hour_options.slice(0, -1),
      onChange: props.onHoursChange,
      value: state[form_name + from_name],
      name: form_name + from_name,
      status: state.status_messages,
      key: type_options,
      className: "mui-centered"
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-schedule-config__item to"
    }, /*#__PURE__*/React.createElement(Select, {
      options: hour_options.slice(1),
      onChange: props.onHoursChange,
      value: state[form_name + to_name],
      name: form_name + to_name,
      status: state.status_messages,
      key: type_options,
      className: "mui-centered"
    })), is__half_type ? /*#__PURE__*/React.createElement("div", {
      className: "c-schedule-config__item sep"
    }) : undefined, is__half_type ? /*#__PURE__*/React.createElement("div", {
      className: "c-schedule-config__item half"
    }, "Apr\xE8s-midi") : undefined, is__half_type ? /*#__PURE__*/React.createElement("div", {
      className: "c-schedule-config__item open"
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: props.onChange,
      value: state[form_name + '[afternoon]'],
      name: form_name + '[afternoon]',
      "left-label": "Non",
      label: "Oui",
      status: state.status_messages,
      className: "mui-switch-centered"
    })) : undefined, is__half_type ? /*#__PURE__*/React.createElement("div", {
      className: "c-schedule-config__item from"
    }, /*#__PURE__*/React.createElement(Select, {
      options: hour_options.slice(0, -1),
      onChange: props.onHoursChange,
      value: state[form_name + '[afternoon_from]'],
      name: form_name + '[afternoon_from]',
      status: state.status_messages,
      key: type_options,
      className: "mui-centered"
    })) : undefined, is__half_type ? /*#__PURE__*/React.createElement("div", {
      className: "c-schedule-config__item to"
    }, /*#__PURE__*/React.createElement(Select, {
      options: hour_options.slice(1),
      onChange: props.onHoursChange,
      value: state[form_name + '[afternoon_to]'],
      name: form_name + '[afternoon_to]',
      status: state.status_messages,
      key: type_options,
      className: "mui-centered"
    })) : undefined);
    return output;
  });
  const output = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: bemit('c-message', ['v2', 'orange', 'auto']) + ' u-margin-top-0 u-margin-bottom-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-message__content"
  }, "Les horaires ci-dessous sont ceux par d\xE9faut et l'ouverture ou la fermeture de l'espace peut \xEAtre sp\xE9cifi\xE9e par date via la page \xAB Gestion des disponibilit\xE9s \xBB.")), /*#__PURE__*/React.createElement("div", {
    className: "space-shedule-config-container"
  }, header, rows));
  return output;
}
